import http from "../axios";

let apiV1LinkReport = {
	baseUrl: '/api/v1/links-reports',
	post: async (dto) => {
		return await http.post(`${apiV1LinkReport.baseUrl}`, dto);
	},
}

export  { apiV1LinkReport }